var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAB508",
    d: "M12 10.286L9 8.588l3-1.731l3 1.731z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5C7FF",
    d: "m4.286 11.679l3.857-2.25v3.75l-3.857 2.25zm7.714 0l3.858-2.25v3.75L12 15.429z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMbox0)",
    d: "m19.715 11.679l-3.857-2.25v3.75l3.857 2.25zm-7.715 0l-3.857-2.25v3.75L12 15.429z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMbox0",
    x1: 8.143,
    x2: 19.714,
    y1: 12.429,
    y2: 12.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6CF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B48F5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMbox);
export default __webpack_public_path__ + "static/media/mbox.6073ab6b5f956e4f3d4fa381e3663507.svg";
export { ForwardRef as ReactComponent };